<mat-form-field
        [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
        [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
        class="autocomplete"
>
    <mat-label *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

    <div
            *ngIf="visibleFlagOnSelect && selectedOption"

            [ngClass]="!selectedOption.classes ? '' : selectedOption.classes"
            class="flag-wrapper"
    ></div>

    <input
            matInput
            #input
            type="text"
            [placeholder]="asFormsControl().placeholder"
            [disabled]="asFormsControl().disabled"
            [matAutocomplete]="autoComplete"
            (input)="filterOptions($event)"
            [ngClass]="{'with-flag': visibleFlagOnSelect && selectedOption}"
            autocomplete="new-password"
    >
    <i class="arrow-down-triangle" aria-hidden="true"></i>
    <mat-autocomplete
        #autoComplete="matAutocomplete"
        (optionSelected)="selectOption($event)"
        (opened)="onTouched && onTouched()"
    >
        <mat-option
                *ngFor="let option of autocompleteOptions | async"
                [value]="option.value">
            <div class="select-item" [ngClass]="{'select-item-with-icon': option.classes}">
                <span [ngClass]="!option.classes ? '' : option.classes"></span>
                <span> {{option.label}}</span>
            </div>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
